"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typography = require("@vds/typography");
var _tooltips = require("@vds-core/tooltips");
var propTypes = {
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool,
  /**
   * @ignore
   * Config object for tooltip option
   */
  tooltip: _propTypes["default"].shape({
    renderAnchorElement: _propTypes["default"].func,
    id: _propTypes["default"].string,
    disabled: _propTypes["default"].bool,
    containerId: _propTypes["default"].string,
    ariaLabel: _propTypes["default"].string,
    size: _propTypes["default"].oneOf(["small", "medium"]),
    children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),
    title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),
    closeButtonText: _propTypes["default"].string
  })
};
var defaultProps = {
  inverted: false
};
var TrailingTooltip = function TrailingTooltip(props) {
  return /*#__PURE__*/_react["default"].createElement(_tooltips.TrailingTooltip, (0, _extends2["default"])({}, props, {
    surface: props.inverted ? "dark" : "light",
    renderTooltipDialog: false // Brand 3.0 only. Default to Popover style
    ,
    Body: _typography.Body,
    Title: _typography.Title,
    Micro: _typography.Micro,
    Subtitle: _typography.Subtitle,
    tooltipIcon: true
  }));
};
TrailingTooltip.propTypes = propTypes;
TrailingTooltip.defaultProps = defaultProps;
var _default = exports["default"] = TrailingTooltip;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/tooltips/dist/cjs/components/TrailingTooltip.js
// module id = 1619
// module chunks = 0